import React from 'react'
import PropTypes from 'prop-types'

import ClickableStar from './ClickableStar'

// TODO: there's an off-by-one thing in here that would be nice to fix
// values are from 0-4, but we report out 1-5
export default class StarRatingInput extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.number,
    onStarClick: PropTypes.func,
    className: PropTypes.string,
  }

  constructor(props) {
    super()

    this.state = {
      value: props.value,
      hoverValue: 0,
      values: [false, false, false, false, false],
    }

    this.timeoutOnStarLeave = false

    this.inputRef = React.createRef(props.value)

    this.onStarClick = this.onStarClick.bind(this)
    this.onStarHover = this.onStarHover.bind(this)
    this.onStarLeave = this.onStarLeave.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value != this.props.value) {
      console.log('here')
      if (this.props.value === -1) {
        const values = [false, false, false, false, false]

        this.setState({
          values: values,
        })
        this.inputRef.current.value = this.props.value
      }
    }
  }

  onStarClick(value) {
    // console.log(`onStarClick ${value}`)

    let values = [false, false, false, false, false]
    for (let i = 0; i < 5; i++) {
      if (i <= value) {
        values[i] = true
      }
    }
    this.setState({
      value: value,
      values: values,
    })
    this.inputRef.current.value = value + 1 // OFF BY ONE UGH

    if (this.props.onStarClick) {
      this.props.onStarClick(value + 1, this.props.name) // OFF BY ONE UGH
    }
  }

  onStarHover(value) {
    // console.log(`onStarHover ${value}`)

    if (this.timeoutOnStarLeave) {
      clearTimeout(this.timeoutOnStarLeave)
    }

    let values = [false, false, false, false, false]
    for (let i = 0; i < 5; i++) {
      if (i <= value) {
        values[i] = true
      }
    }
    this.setState({
      values: values,
    })
  }

  onStarLeave() {
    // console.log(`onStarLeave ${value}`)

    this.timeoutOnStarLeave = setTimeout(() => {
      let values = [false, false, false, false, false]
      for (let i = 0; i < 5; i++) {
        if (i <= this.state.value) {
          values[i] = true
        }
      }
      this.setState({
        values: values,
      })

      this.timeoutOnStarLeave = false
    }, 200)
  }

  render() {
    const { className } = this.props

    return (
      <div className={'clickable-star-rating ' + className}>
        <ClickableStar
          key={0}
          value={0}
          role="button"
          onClick={this.onStarClick}
          onMouseOver={this.onStarHover}
          onMouseLeave={this.onStarLeave}
          isActive={this.state.values[0]}
        />
        <ClickableStar
          key={1}
          value={1}
          role="button"
          onClick={this.onStarClick}
          onMouseOver={this.onStarHover}
          onMouseLeave={this.onStarLeave}
          isActive={this.state.values[1]}
        />
        <ClickableStar
          key={2}
          value={2}
          role="button"
          onClick={this.onStarClick}
          onMouseOver={this.onStarHover}
          onMouseLeave={this.onStarLeave}
          isActive={this.state.values[2]}
        />
        <ClickableStar
          key={3}
          value={3}
          role="button"
          onClick={this.onStarClick}
          onMouseOver={this.onStarHover}
          onMouseLeave={this.onStarLeave}
          isActive={this.state.values[3]}
        />
        <ClickableStar
          key={4}
          value={4}
          role="button"
          onClick={this.onStarClick}
          onMouseOver={this.onStarHover}
          onMouseLeave={this.onStarLeave}
          isActive={this.state.values[4]}
        />
        <input key={'rating'} type="hidden" name="rating" ref={this.inputRef} />
      </div>
    )
  }
}
